var trim = require('./trim');

module.exports = function underscored(str) {
  return trim(str).replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/underscored.js
// module id = 316
// module chunks = 0